import { NumberField, SelectField } from 'react-admin';

import { GetContractFeeChargesEndpoint } from '@Common/types/bo/b2b/contract_fee_charges';

import {
  contractFeeChargesFeeLabelChoices,
  contractFeeChargesPaidByChoices,
} from '@sh4res/bo-common/components';
import { CurrencyField, IdField, UTCDateField } from '@sh4res/bo-common/fields';
import { ColumnList } from '@sh4res/bo-common/utils';

export const ContractFeeChargesListColumns: ColumnList<
  GetContractFeeChargesEndpoint['Client']['ResponseBody'][number]
> = {
  id: (
    <IdField
      reference="contract_fee_charges"
      data-testid={'BoExternalContractFeeChargesList_IdField'}
    />
  ),
  paid_by: (
    <SelectField
      choices={contractFeeChargesPaidByChoices}
      data-testid={'BoExternalContractFeeChargesList_PaidByField'}
    />
  ),
  b2b_company_id: (
    <IdField
      reference="companies"
      data-testid={'BoExternalContractFeeChargesList_CompanyIdField'}
    />
  ),
  b2b_contract_id: (
    <IdField
      reference="contracts"
      data-testid={'BoExternalContractFeeChargesList_ContractIdField'}
    />
  ),
  b2b_contract_version_num: (
    <NumberField data-testid={'BoExternalContractFeeChargesList_ContractVersionNumField'} />
  ),
  fee_label: (
    <SelectField
      choices={contractFeeChargesFeeLabelChoices}
      data-testid={'BoExternalContractFeeChargesList_FeeLabelField'}
    />
  ),
  amount: (
    <CurrencyField currency="EUR" data-testid={'BoExternalContractFeeChargesList_AmountField'} />
  ),
  created_at: <UTCDateField data-testid={'BoExternalContractFeeChargesList_CreatedAtField'} />,
  updated_at: <UTCDateField data-testid={'BoExternalContractFeeChargesList_UpdatedAtField'} />,
};
